<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8GYk4R/tc-custom/9781783038121.jpg?1729379451102" alt="This image is the cover for the book American Expeditionary Force, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Expeditionary Force, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <p>When the United States entered the war in April 1917 the belligerents were approaching exhaustion. It had been hoped by the Generals in both Britain and France that untold numbers of fresh troops would be assimilated into their respective commands. However, this idea was firmly resisted, America would field its own army alongside the Allies it would have its own section on the front line. Those with concerns that the untried divisions under General Pershing would fair badly against the seasoned German military machine were soon reassured as impressive victories were won by the newcomers. The book is split into eight chapters which deal with different pivotal moments during the First World War from the American perspective, from the reasons behind the American involvement in the war and initial training to the major battles at Cantigny, Chateau Thierry and St. Mihiel. This story is told in pictures gleaned from the official archives which were first published in 1920 and now presented for reexamination and public awareness in the Images of War series.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Holroyd
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a17535a